import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { ICustomColumn } from '../../../../../../common/types/commonTypes';
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks';
import { fitmentTimeReportFiltersSelector, reportIsVisibleSelector } from '../../../../../../store/selectors/reportsSelectors';
import Thead from '../../../../../../core/components/table-components/Thead';
import Tr from '../../../../../../core/components/table-components/Tr';
import ThWithControls from '../../../../../../core/components/table-components/ThWithControls';
import ThNew from '../../../../../../core/components/table-components/table-new/ThNew';
import Dropdown from '../../../../../../core/components/dropdown/Dropdown';
import {
  getFitmentTimeReportExcelThunk, getFitmentTimeReportThunk,
} from '../../../../../../store/thunks/reports/reportsThunks';
import { setFitmentTimeFilters } from '../../../../../../store/slices/reportsSlice';
import { useRectificationReportRanges } from '../../../../../hooks/useFitmentTimeReportRanges';

type FitmentTimeColumnsProps = {
  columns: ICustomColumn[],
  totalElements: number,
}

const FitmentTimeColumns: React.FC<FitmentTimeColumnsProps> = ({ columns, totalElements }) => {
  const dispatch = useAppDispatch();
  const reportIsVisible = useAppSelector(reportIsVisibleSelector);
  const filters = useAppSelector(fitmentTimeReportFiltersSelector);

  const { range, setRange, rangePatterns } = useRectificationReportRanges();

  const sortHandle = (field: number) => {
    if (filters.order?.field === field) {
      const newFilters = {
        ...filters,
        order: { ...filters.order, isAsc: !filters.order.isAsc },
      };
      dispatch(setFitmentTimeFilters(newFilters));
      dispatch(getFitmentTimeReportThunk({ filters: newFilters }));
    } else {
      const newFilters = {
        ...filters,
        order: { field, isAsc: true },
      };
      dispatch(setFitmentTimeFilters(newFilters));
      dispatch(getFitmentTimeReportThunk({ filters: newFilters }));
    }
  };

  const setRangeHandle = (field: string, value: [number, number]) => {
    const [min, max] = value;
    const newFilters = {
      ...filters,
      [field]: { min, max },
      page: 1,
    };
    dispatch(setFitmentTimeFilters(newFilters));
    dispatch(getFitmentTimeReportThunk({ filters: newFilters }));
  };

  const exportToExcel = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { page, pageSize, ...rest } = filters;
    dispatch(getFitmentTimeReportExcelThunk({ filters: rest }));
  };

  return (
    <Thead>
      <Tr>
        {columns.map((col) => (
          <ThWithControls
            key={col.dataIndex}
            col={col}
            tableFilters={filters}
            sortHandle={sortHandle}
            setRangeHandle={setRangeHandle}
            range={range}
            rangePatterns={rangePatterns}
            setRange={setRange}
            totalElements={totalElements}
            className={`fitmentTimeReportTh--${col.dataIndex}`}
            disabledFilter={!reportIsVisible}
          />
        ))}
        <ThNew action>
          <Dropdown
            disabled={!totalElements}
            menuItems={[
              {
                label: 'Export to Excel',
                icon: <FontAwesomeIcon icon={faFileExcel} />,
                key: 'export-to-excel',
                onClick: exportToExcel,
              },
            ]}
            icon={<FontAwesomeIcon icon={faGear} />}
          />
        </ThNew>
      </Tr>
    </Thead>
  );
};

export default FitmentTimeColumns;
